@if (customerId$ | async; as customerId) {
  <div data-test="customer-navigation">
    @if (!!customerId) {
      <nav mat-tab-nav-bar [tabPanel]="tabPanel" color="accent">
        <a mat-tab-link [routerLink]="['/customer', customerId]" [active]="isDetails$ | async"
          >{{ 'app.customer.navigation.details' | translate }}
        </a>
        <a
          mat-tab-link
          [routerLink]="['/customer', customerId, 'location']"
          [active]="isLocations$ | async"
          >{{ 'app.customer.navigation.locations' | translate }}
        </a>
      </nav>
      <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
    }
  </div>
}
